import { render, staticRenderFns } from "./goodsSelect.vue?vue&type=template&id=54bee775&scoped=true&"
import script from "./goodsSelect.vue?vue&type=script&lang=js&"
export * from "./goodsSelect.vue?vue&type=script&lang=js&"
import style0 from "./goodsSelect.vue?vue&type=style&index=0&id=54bee775&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../yiweb/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54bee775",
  null
  
)

export default component.exports